export default {"src":"/_next/static/media/icon-network.4e0a1a90.svg","height":1600,"width":1600};